import React from 'react';
import { Loader2, LoaderCircle } from 'lucide-react';

export const LoadingSpinner = () => {
  return (
      <div className="flex items-center justify-center h-screen">
        <LoaderCircle className="animate-spin"></LoaderCircle>
      </div>
    
  );
};

// Also provide a default export
export default LoadingSpinner; 